import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    shippedItems: [],
};

const shippedItemsManagementSlice = createSlice({
    name: 'shipped',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getShippedSuccess(state, action) {
            state.isLoading = false;
            state.shippedItems = action.payload;
        },
    },
});

export default shippedItemsManagementSlice.reducer;

export const { startLoading, hasError, getShippedSuccess } = shippedItemsManagementSlice.actions;

export const getAllShippedItems = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('shipments/all-shipped-items');
        dispatch(getShippedSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};
